import CampaignsService from 'services/campaignsService';

const InitialiseUser = async (getAuthToken: () => Promise<string>): Promise<void> => {
  const token = await getAuthToken();

  const service = new CampaignsService(token);

  await service.campaignsService.post('InitialiseUser', undefined);
};

export default InitialiseUser;
